import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import AccountsTab from './AccountsTab';
import PostTab from './PostTab';
import AuditTab from './AuditTab';
import PersonasTab from './PersonasTab';
import InboxTab from './InboxTab';
import SuggestionsTab from './SuggestionsTab';
import DraftsTab from './DraftsTab';
import SchedulerTab from './SchedulerTab';
import ConversationsTab from './ConversationsTab';
import OverviewTab from './OverviewTab';
import { api } from './api';

/** /engagement: the Engagement Centre: accounts, personas and memory, posting as them, activity log. */
export default class EngagementPage extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle('Engagement Centre');
    this.tab = 'overview';
    const state = this.state = {
      accounts: null,
      aiReady: false,
      selected: null,
      load: () => this.load()
    };
    if (app.forum.attribute('vouchaEngagement')) this.load();
    void state;
  }
  load() {
    return api('GET', '/accounts').then(r => {
      this.state.accounts = r.accounts || [];
      this.state.aiReady = !!r.aiReady;
      this.state.groupId = r.groupId;
      this.state.options = r.options || {
        available: false
      };
      if (this.state.selected && !this.state.accounts.some(a => a.userId === this.state.selected && a.status === 'active')) this.state.selected = null;
    }).catch(() => this.state.accounts = []).finally(() => m.redraw());
  }
  view() {
    if (!app.forum.attribute('vouchaEngagement')) {
      return m("div", {
        className: "VEC container"
      }, m("p", {
        className: "VEC-empty"
      }, "This page is for the Voucha team."));
    }
    const tabs = [['overview', 'Overview', 'fas fa-chart-line'], ['accounts', 'Accounts', 'fas fa-users'], ['personas', 'Personas & memory', 'fas fa-user-cog'], ['inbox', 'Inbox', 'fas fa-inbox'], ['suggestions', 'Suggestions', 'fas fa-lightbulb'], ['drafts', 'Drafts' + (this.state.draftCounts && this.state.draftCounts.pending ? ' (' + this.state.draftCounts.pending + ')' : ''), 'fas fa-file-alt'], ['conversations', 'Conversations', 'fas fa-comments'], ['scheduler', 'Scheduler', 'fas fa-clock'], ['post', 'Post', 'fas fa-pen'], ['audit', 'Activity log', 'fas fa-history']];
    return m("div", {
      className: "VEC container"
    }, m("header", {
      className: "VEC-head"
    }, m("div", null, m("h1", null, "Engagement Centre"), m("p", {
      className: "VEC-help"
    }, "Voucha-managed accounts: everything they post carries the Voucha Team badge, and they're listed on the public", ' ', m("a", {
      href: app.route('voucha-engagement.directory'),
      target: "_blank",
      rel: "noopener"
    }, "Voucha Team page"), ". Every action here is logged."))), m("nav", {
      className: "VEC-tabs"
    }, tabs.map(_ref => {
      let [key, label, icon] = _ref;
      return m(Button, {
        className: 'Button' + (this.tab === key ? ' is-active' : ''),
        icon: icon,
        onclick: () => this.tab = key
      }, label);
    })), this.tab === 'overview' ? m(OverviewTab, {
      state: this.state,
      go: t => this.tab = t
    }) : null, this.tab === 'accounts' ? m(AccountsTab, {
      state: this.state,
      onPostAs: id => {
        this.state.selected = id;
        this.tab = 'post';
      }
    }) : null, this.tab === 'personas' ? m(PersonasTab, {
      state: this.state
    }) : null, this.tab === 'inbox' ? m(InboxTab, {
      state: this.state
    }) : null, this.tab === 'suggestions' ? m(SuggestionsTab, {
      state: this.state
    }) : null, this.tab === 'drafts' ? m(DraftsTab, {
      state: this.state
    }) : null, this.tab === 'conversations' ? m(ConversationsTab, {
      state: this.state
    }) : null, this.tab === 'scheduler' ? m(SchedulerTab, {
      state: this.state
    }) : null, this.tab === 'post' ? m(PostTab, {
      state: this.state
    }) : null, this.tab === 'audit' ? m(AuditTab, {
      state: this.state
    }) : null);
  }
}